<app-feature-hero
  title="Ticket Management <br />Software Solutions"
  description="The perfect solution to streamline customer support tickets efficiently"
  image=""
  imageAlt=""
></app-feature-hero>

<app-feature-row
  headingLevel="h2"
  heading="What is Ticket Management Software?"
  [paragraphs]="whatIsParagraphs"
  image="/assets/img/feature-pages/infraon-assets/ticket-management/ticket-management-feature-img.png"
  imageAlt="hardware asset management"
  imagePosition="right"
></app-feature-row>

<section class="section-spacing benefits-of-ticket-management">
  <div class="container">
    <div class="row mx-0">
      <h2 class="section-title p-b-60">Benefits of Ticket Management Software</h2>
    </div>

    <div class="row mx-0">
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3">
        <div class="benifits-box p-2 d-flex flex-column justify-content-center align-items-start">
          <img
            style="max-width: 78px"
            src="/assets/img/feature-pages/infraon-assets/ticket-management/git-branch-beigh-01.svg"
            class="mb-3"
            alt="Git branch Colored Beige"
          />
          <div>
            <h3 class="section-title-s text-start">Automated ticketing processes</h3>
            <p class="section-paragraph">
              Ticket management software can automate most of the manual processes associated with
              managing tickets, such as assigning tickets, tracking progress, and creating reports.
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3">
        <div class="benifits-box p-2 d-flex flex-column justify-content-center align-items-start">
          <img
            style="max-width: 78px"
            src="/assets/img/feature-pages/infraon-assets/ticket-management/up-arrow-beigh-01.svg"
            class="mb-3"
            alt="Up arrow colored beige"
          />
          <div>
            <h3 class="section-title-s text-start">Increased efficiency</h3>
            <p class="section-paragraph">
              By automating mundane tasks, ticket management software can help teams become more
              efficient and improve their overall performance. Automation also ensures fewer errors.
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3">
        <div class="benifits-box p-2 d-flex flex-column justify-content-center align-items-start">
          <img
            style="max-width: 78px"
            src="/assets/img/feature-pages/infraon-assets/ticket-management/pointer-beigh-01.svg"
            class="mb-3"
            alt="Pointer icon colored beige"
          />
          <div>
            <h3 class="section-title-s text-start">Better prioritization</h3>
            <p class="section-paragraph">
              Ticket management software helps teams to organize and track their tickets, making it
              easier to prioritize, assign, and manage customer requests.
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3">
        <div class="benifits-box p-2 d-flex flex-column justify-content-center align-items-start">
          <img
            style="max-width: 78px"
            src="/assets/img/feature-pages/infraon-assets/ticket-management/network-beigh-01.svg"
            class="mb-3"
            alt="Network Icon Colored Beige"
          />
          <div>
            <h3 class="section-title-s text-start">Increased productivity</h3>
            <p class="section-paragraph">
              With automated ticketing processes, teams spend less time managing and more time
              focusing on building customer relationships, leading to increased productivity.
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3 bottom-row-margin">
        <div
          class="benifits-box p-2 pb-0 d-flex flex-column justify-content-center align-items-start"
        >
          <img
            style="max-width: 78px"
            src="/assets/img/feature-pages/infraon-assets/ticket-management/headerphone-beigh-01.svg"
            class="mb-3"
            alt="Headphones Icon Colored Beige"
          />
          <div>
            <h3 class="section-title-s text-start">Improved customer service</h3>
            <p class="section-paragraph">
              Efficient ticket management allows teams to respond quickly and efficiently to
              customer inquiries and requests, resulting in improved customer service.
            </p>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 mb-3 bottom-row-margin">
        <div
          class="benifits-box p-2 pb-0 d-flex flex-column justify-content-center align-items-start"
        >
          <img
            style="max-width: 78px"
            src="/assets/img/feature-pages/infraon-assets/ticket-management/chat-beigh-01.svg"
            class="mb-3"
            alt="Chart Icon colored beige"
          />
          <div>
            <h3 class="section-title-s text-start">Improved communication</h3>
            <p class="section-paragraph">
              Ticket management software provides an easy way for teams to communicate and
              collaborate on tickets, resulting in better coordination and quicker responses.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-feature-row
  headingLevel="h2"
  heading="What is Automated Ticketing Management?"
  [paragraphs]="automatedTicketingParagraphs"
  image="/assets/img/feature-pages/infraon-assets/ticket-management/automated-ticket-management-feature-img.webp"
  imageAlt="hardware asset management"
  imagePosition="right"
></app-feature-row>

<section class="section-spacing trial-section primary-bg ineffective-it-asset-management-tools">
  <div class="container">
    <h2 class="section-title text-white text-center mt-4 mb-0">
      Say Goodbye To Those Ineffective IT <br />
      Asset Management Tools
    </h2>

    <a
      class="secondary-buttons cta-buttons rounded-l"
      [routerLink]="['/registration']"
      [queryParams]="{ type: 'trial' }"
      style="margin: auto; margin-top: 2rem"
      >Start Your Free Trial</a
    >
  </div>
</section>

<section class="container section-spacing">
  <div id="gdpr-wrapper">
    <div class="gdpr-section justify-content-center">
      <img src="/assets/img/feature-pages/gdpr.webp" alt="GDPR Logo" class="me-4 w-100" />
      <div>
        <h2 class="section-title mb-3">Our Product Suite is GDPR-Compliant</h2>
        <p class="section-paragraph mb-0">
          We are compliant with the European General Data Protection Regulation (GDPR) – and <br />
          our SaaS-based product suite is fully committed to protecting the data of our customers
          <br />
          as per the recent standards.
        </p>
      </div>
    </div>
  </div>
</section>

<section class="container section-spacing">
  <h2 class="section-title text-center p-b-60">Features of Ticket Management software</h2>

  <div class="row mx-0 justify-content-evenly">
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/config.svg"
          alt="Config Icon"
        />
      </div>
      <p class="section-title-s">Create and manage tickets</p>
      <p class="section-paragraph-s">
        Ticket management software allows you to quickly and easily manage tickets from creation to
        resolution./p>
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/branch-small.svg"
          alt="Git branch icon small"
        />
      </div>
      <p class="section-title-s">Automate ticket routing</p>
      <p class="section-paragraph-s">
        Automatically assign tickets to the right customer support agent or team based on the
        ticket's content.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/fast-forward-01.svg"
          alt="Fast forward icon"
        />
      </div>
      <p class="section-title-s">Escalation management</p>
      <p class="section-paragraph-s">
        Automatically escalate tickets to higher levels of support when necessary.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/document.svg"
          alt="Document Icon"
        />
      </div>
      <p class="section-title-s">Customizable ticket forms</p>
      <p class="section-paragraph-s">
        Create custom ticket forms to collect the necessary information for each ticket.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/tv-01.svg"
          alt="TV Icon"
        />
      </div>
      <p class="section-title-s">Multi-channel support</p>
      <p class="section-paragraph-s">
        Allow customers to submit tickets via email, phone, web, or social media.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/stack.svg"
          alt="Stack icon"
        />
      </div>
      <p class="section-title-s">Knowledge base</p>
      <p class="section-paragraph-s">
        Provide a searchable database of accessible solutions to common issues.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/cell-phones-small.svg"
          alt="Cell phone icon 2"
        />
      </div>
      <p class="section-title-s">Mobile access</p>
      <p class="section-paragraph-s">
        Track customer satisfaction ratings to ensure that tickets are addressed in a timely manner.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/statistic-01.svg"
          alt="statistics Icon"
        />
      </div>
      <p class="section-title-s">Reporting and analytics</p>
      <p class="section-paragraph-s">
        Allow agents to access and manage tickets on the go with mobile access, reducing response
        time.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/config.svg"
          alt="Config Icon"
        />
      </div>
      <p class="section-title-s">SLA Management</p>
      <p class="section-paragraph-s">
        Generate reports and analytics to track ticket volume, response times, resolution times, and
        more.
      </p>
    </div>

    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 px-5 mb-5 bottom-row-margin">
      <div class="mb-3">
        <img
          class="d-block mx-auto"
          src="/assets/img/feature-pages/infraon-assets/ticket-management/smiley-01.svg"
          alt="Smiley Icon"
        />
      </div>
      <p class="section-title-s">Customer satisfaction tracking</p>
      <p class="section-paragraph-s">
        Set service level agreements and ensure that tickets are responded to in the allotted time
        frame.
      </p>
    </div>
  </div>
</section>

<app-feature-row
  headingLevel="h2"
  heading="How does Infraon Ticketing Software work?"
  [paragraphs]="howItWorksParagraphs"
  image="/assets/img/feature-pages/infraon-assets/ticket-management/Group21611.png"
  imageAlt="hardware asset management"
  imagePosition="right"
></app-feature-row>

<section class="section-spacing bg-grey">
  <div class="container" id="g2-box-wrapper">
    <div class="g2-box justify-content-between">
      <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo" />
      <p>
        Already love using our products? Please <br />
        share your experiences on G2
      </p>
      <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button"
        >Rate us</a
      >
    </div>
  </div>
</section>

<section class="container section-spacing">
  <h2 class="section-title text-center">Related Content</h2>

  <div class="row mx-0">
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
      <a routerLink="/it-asset-management/features/it-assets-management-solutions">
        <div class="backlink-container bg-white px-5 py-4 h-100">
          <p class="section-title-s text-start">
            <strong> IT asset management </strong>
          </p>
          <p class="section-paragraph-s text-start">
            Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to
            optimize your IT asset usage. Make smart purchasing...
          </p>
          <p class="primary-color mb-0">Know more</p>
        </div>
      </a>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
      <a routerLink="/it-asset-management/features/software-assets-management-solutions">
        <div class="backlink-container bg-white px-5 py-4 h-100">
          <p class="section-title-s text-start">
            <strong> Software asset management </strong>
          </p>
          <p class="section-paragraph-s text-start">
            Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to
            optimize your IT asset usage. Make smart purchasing...
          </p>
          <p class="primary-color mb-0">Know more</p>
        </div>
      </a>
    </div>
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
      <a routerLink="/it-asset-management/features/software-license-management">
        <div class="backlink-container bg-white px-5 py-4 h-100">
          <p class="section-title-s text-start">
            <strong> Software Licensing management </strong>
          </p>
          <p class="section-paragraph-s text-start">
            Infraon Assets helps you manage the lifecycles of fixed assets like PCs, laptops,
            furniture, storage devices, etc., with a 360-degree view...
          </p>
          <p class="primary-color mb-0">Know more</p>
        </div>
      </a>
    </div>
  </div>
</section>

<app-feature-row
  headingLevel="h2"
  heading="Key Features"
  listStyle="check"
  checkIconSize="lg"
  [checklistColumns]="2"
  [listItems]="keyFeaturesItems"
  image="/assets/img/feature-pages/infraon-assets/ticket-management/Group1935.png"
  imageAlt="Dashboards and reports for IT, Hardware, and Software Assets"
  imageStyle="box-shadow: none;"
  imagePosition="left"
  buttonLabel="Get started with free trial"
  [buttonLink]="['/registration']"
  [buttonQueryParams]="{ type: 'trial' }"
  [buttonIcon]="false"
></app-feature-row>
